export const checkAdminRole = (roles) => roles?.some((role) => role === 'SUPER_ADMIN' || role === 'REGULAR_ADMIN');

export const checkAuthorOrInstructorRole = (roles) =>
  roles?.some(
    (role) => role === 'AUTHOR' || role === 'INSTRUCTOR' || role === 'SUPER_ADMIN' || role === 'REGULAR_ADMIN'
  );
